import { useEffect, useState } from "react";

import { providerRequests } from "@/api/(requests)/provider";

/**
 * Fetches tips, banner, draft notes count, and patient count for the provider dashboard.
 * @returns {{ banner: Object|null, patientCount: number|null, providerDraftNotes: number, tips: Array|null }}
 */
export function useDashboardData() {
  const [banner, setBanner] = useState(null);
  const [patientCount, setPatientCount] = useState(null);
  const [providerDraftNotes, setProviderDraftNotes] = useState(0);
  const [tips, setTips] = useState(null);

  useEffect(() => {
    const context = { showLoader: false };

    providerRequests
      .fetch_aptihealth_tips({ context })
      .then((response) => {
        setTips(response.tips);
      })
      .catch((err) => {
        console.error("Failed to fetch aptihealth tips:", err);
      });

    providerRequests
      .fetch_provider_banner({ context })
      .then((response) => {
        if (response && Object.keys(response).length > 0) {
          setBanner(response);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch provider banner:", err);
      });

    providerRequests
      .fetch_provider_draft_notes_count()
      .then((response) => {
        setProviderDraftNotes(response);
      })
      .catch((err) => {
        console.error("Failed to fetch draft notes count:", err);
      });

    providerRequests
      .fetch_patient_count()
      .then((response) => {
        setPatientCount(response.user);
      })
      .catch((err) => {
        console.error("Failed to fetch patient count:", err);
      });
  }, []);

  return { banner, patientCount, providerDraftNotes, tips };
}
